<template>
  <v-container grid-list-md fluid text-xs-center style="min-height: 93.4vh;">
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home">
        <v-toolbar-title>{{ $t('home.title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <div id="scrolling-home" class="scroll-y scrollDesign" style="max-height: 80vh;">
        <v-flex xs12 mt-1>
          <v-layout row wrap>
            <v-flex
              xs12
              sm3
              md3
              l2
              xl2
              v-for="item in menu"
              :key="item.nombre"
              @click="pushRoute(item)"
              v-show="permits[item.permit]"
            >
              <v-hover class="zoomD">
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 4 : 0}`"
                >
                  <v-expand-transition
                    v-if="item.permit != 'WATCH_CART' && !permits[item.permit]"
                  >
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out primary darken-2 v-card--reveal display-1 white--text"
                      style="height: 100%; z-index: 1;"
                    >
                      {{ $t("home.unAuthorized") }}
                    </div>
                  </v-expand-transition>
                  <v-expand-transition v-if="item.permit == 'WATCH_CART'">
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out primary darken-2 v-card--reveal display-1 white--text"
                      style="height: 100%; z-index: 1;"
                    >
                      {{ $t("home.inDevelopment") }}
                    </div>
                  </v-expand-transition>
                  <v-card-title primary-title>
                    <v-flex
                      xs12
                      v-if="item.nombre == 'Actualizaciones'"
                      @click="teste()"
                    >
                      <v-layout row wrap justify-center>
                        <v-flex xs6>
                          <v-badge
                            style="float: right;"
                            bordered
                            overlap
                            color="#ff0000"
                            v-show="statusUp()"
                          >
                            <template v-slot:badge>
                              <span>{{ num }}</span>
                            </template>
                          </v-badge>
                          <v-img
                            :src="
                              require('@/assets/panel/home/' + item.iconImage)
                            "
                          ></v-img>
                        </v-flex>
                      </v-layout>
                      <div class="headline">{{ $t(item.name) }}</div>
                      <span>{{ $t(item.descriptiion) }}</span>
                    </v-flex>
                    <v-flex xs12 v-else>
                      <v-layout row wrap justify-center>
                        <v-flex xs6>
                          <v-img
                            :src="
                              require('@/assets/panel/home/' + item.iconImage)
                            "
                          ></v-img>
                        </v-flex>
                      </v-layout>
                      <div class="headline">{{ $t(item.name) }}</div>
                      <span>{{ $t(item.descriptiion) }}</span>
                    </v-flex>
                  </v-card-title>
                </v-card>
              </v-hover>
            </v-flex>
            <v-flex
              xs12
              sm3
              md3
              l2
              xl2
              v-for="item in worshopsModules"
              :key="item.nombre"
              @click="pushRoute(item)"
              v-show="!isNormalSchool_()"
            >
              <v-hover class="zoomD">
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 4 : 0}`"
                >
                  <v-card-title primary-title>
                    <v-flex xs12>
                      <v-layout
                        row
                        wrap
                        justify-center
                      >
                        <v-flex xs6>
                          <v-img :src="require('@/assets/panel/home/'+item.iconImage)" />
                        </v-flex>
                      </v-layout>
                      <div class="headline">
                        {{ $t(item.name) }}
                      </div>
                      <span>{{ $t(item.descriptiion) }}</span>
                    </v-flex>
                  </v-card-title>
                </v-card>
              </v-hover>
            </v-flex>
            <v-flex xs12 sm3 md3 l2 xl2>
              <v-hover class="zoomD">
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 4 : 0}`"
                >
                  <a
                    style="color: #000000; text-decoration:none"
                    href="https://sites.google.com/kiritek.com/centrodeayudaskolable"
                    target="_blank"
                  >
                    <v-card-title primary-title>
                      <v-flex xs12>
                        <v-layout row wrap justify-center>
                          <v-flex xs6>
                            <v-img
                              :src="
                                require('@/assets/panel/home/SKLB-Help.png')
                              "
                            ></v-img>
                          </v-flex>
                        </v-layout>
                        <div class="headline">Centro de ayuda</div>
                        <span
                          >Herramienta web donde compartimos material de apoyo
                          acerca de Skolable</span
                        >
                      </v-flex>
                    </v-card-title>
                  </a>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </div>
    </v-layout>
    <GlobalPollsModal />
  </v-container>
</template>

<script>
import GlobalPollsModal from "../../Modals/GlobalPollsModal.vue";
import { mapGetters } from "vuex";
import { isNormalSchool } from '../../../plugins/GeneralMethods';
export default {
  components: {
    GlobalPollsModal,
  },
  data: () => ({
    permits: [],
    worshopsModules: [
      {
        nombre: "Talleres",
        name: "panel.workshop",
        descriptiion: "panel.workshopDesc",
        route: "workshop",
        activo: false,
        icon: "home_repair_service",
        iconSelected: "home_repair_service",
        desc: "Visualiza, administra, descarga y crea nuevos talleres",
        iconImage: "Workshop.png",
        permit: "WATCH_VISITS"
      },
      {
        nombre: "Salones",
        name: "panel.classroom",
        descriptiion: "panel.classroomDesc",
        route: "classroom",
        activo: false,
        icon: "meeting_room",
        iconSelected: "meeting_room",
        desc: "Visualiza, administra, descarga y crea nuevos salones ",
        iconImage: "Classroom.png",
        permit: "WATCH_VISITS"
      },
      {
        nombre: "Días de asueto",
        name: "panel.holiday",
        descriptiion: "panel.holidayDesc",
        route: "holidays",
        activo: false,
        icon: "celebration",
        iconSelected: "celebration",
        desc: "Visualiza, administra, descarga y crea días de asueto ",
        iconImage: "Holiday.png",
        permit: "WATCH_VISITS"
      },
    ],
versionAdmin: "",
    versionStaff: "",
    versionTutorA: "",
    versionTutorIO: "",
    set: "",
    num: 0,
  }),
  watch: {
    getUser() {
      this.mapPermits();
    }
  },
  mounted() {
    if (this.getUser && this.getUser.id) this.mapPermits();
  },
  methods: {
    isNormalSchool_(){
      return isNormalSchool(this.getBranch)
    },
    contUpdate() {
      this.num = 0;
      if (localStorage.getItem("APP_VERSION") != this.versionAdmin) {
        this.num++;
      }
      if (localStorage.getItem("TUTORS_VERSIONIO") != this.versionTutorIO) {
        this.num++;
      }
      if (
        localStorage.getItem("STAFF_VERSION") != this.versionStaff ||
        localStorage.getItem("TUTORS_VERSIONA") != this.versionTutorA
      ) {
        this.num++;
      }
    },
    mapPermits() {
      //Admin
      this.versionAdmin = this.getUser.versions[7].version.split(".");
      for (let a = 0; a < this.versionAdmin.length - 1; a++) {
        this.set = this.set + this.versionAdmin[a] + ".";
      }
      this.versionAdmin = this.set.substring(0, this.set.length - 1);
      this.set = "";
      //Staff
      this.versionStaff = this.getUser.versions[0].version.split(".");
      for (let a = 0; a < this.versionStaff.length - 1; a++) {
        this.set = this.set + this.versionStaff[a] + ".";
      }
      this.versionStaff = this.set.substring(0, this.set.length - 1);
      this.set = "";
      //TutorAndroid
      this.versionTutorA = this.getUser.versions[1].version.split(".");
      for (let a = 0; a < this.versionTutorA.length - 1; a++) {
        this.set = this.set + this.versionTutorA[a] + ".";
      }
      this.versionTutorA = this.set.substring(0, this.set.length - 1);
      this.set = "";
      //TutorIOS
      this.versionTutorIO = this.getUser.versions[2].version.split(".");
      for (let a = 0; a < this.versionTutorIO.length - 1; a++) {
        this.set = this.set + this.versionTutorIO[a] + ".";
      }
      this.versionTutorIO = this.set.substring(0, this.set.length - 1);
      this.set = "";

      var usr = this.getUser;
      var wbRol = usr.webRole;
      var catalogs = wbRol.catalogs;
      for (var c in catalogs) {
        if (catalogs[c].name.includes("WATCH")) {
          this.permits[catalogs[c].name] = 1;
        }
      }
      this.contUpdate();
      this.$forceUpdate();
    },
    pushRoute(item) {
      if (item.permit != "WATCH_CART" && this.permits[item.permit])
        this.$router.push(item.route);
    },
    statusUp() {
      if (
        localStorage.getItem("APP_VERSION") == this.versionAdmin ||
        localStorage.getItem("STAFF_VERSION") == this.versionStaff ||
        localStorage.getItem("TUTORS_VERSIONA") == this.versionTutorA ||
        localStorage.getItem("TUTORS_VERSIONIO") == this.versionTutorIO
      ) {
        return false;
      } else {
        return true;
      }
    },
    teste() {
      localStorage.setItem("APP_VERSION", this.versionAdmin);
      localStorage.setItem("STAFF_VERSION", this.versionStaff);
      localStorage.setItem("TUTORS_VERSIONA", this.versionTutorA);
      localStorage.setItem("TUTORS_VERSIONIO", this.versionTutorIO);
    },
    goWorkshop(){
      this.$router.push("workshop");
    },
    goClassroom(){
      this.$router.push("classroom");
    },
    goHoliday(){
      this.$router.push("holidays");
    }
  },
  computed: {
    ...mapGetters(["getUser","getBranch"]),

    menu() {
      return this.$store.getters.getMenuItems;
    }
  }
};
</script>

<style lang="sass" scoope>
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css")
</style>
<style>
  .zoomD {
    background-color: rgb(255, 255, 255);
    transition: transform .2s; /* Animation */
    margin: 0 auto;
  }

  .zoomD:hover {
    transform: scale(1.02); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
    background-color: rgb(255, 255, 255);
  }
</style>

